import { useLocation } from "react-router-dom";
import { useMemo } from "react";

/**
 * Determines whether the current route includes a valid dataset query parameter
 * that should unlock analytics-backed custom data.
 */
const useAnalyticsDatasetFlag = () => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const datasetParam = params.get("dataset");

    if (!datasetParam) {
      return false;
    }

    const normalized = datasetParam.trim().toLowerCase();
    return normalized !== "" && normalized !== "unidentified";
  }, [location.search]);
};

export default useAnalyticsDatasetFlag;
